import { Link, useNavigate } from 'react-router-dom';
import './SignupWeb2.css';
import { Button, Checkbox, CountrySelect, StepProgress } from '../../ui';
import { useDevice, useSignupWeb2 } from '../../../hooks';
import { SignupStatuses } from '../../../enums';
import { ValidateEmail } from '.';
import { SignupPasswordModel } from '../../../models';
import { getLinkWithParams } from '../../../utils';
import { useCountryContext } from '../../../contexts';

export function SignupWeb2() {
   const { countries } = useCountryContext();
   const {
      submitCheck,
      signupStatus,
      setSignupStatus,
      isLoading,
      submitSignup,
      securityMathInput,
      setSecurityMathInput,
      securityMathPassed,
      securityMathQuestion,
      setIsLoginModalOpen,
      signupCheckForm,
      signupPasswordForm,
      submitPassword,
      stepInfo,
      googleButtonRef,
   } = useSignupWeb2();

   const { isMobile } = useDevice();
   const navigate = useNavigate();

   return (
      <div className="signup-page flex w-100 h-100 ">
         {!isMobile && <div className="flex-1"></div>}
         <div className="flex-1 form-container signup-container flex flex-col justify-center items-center gap-4 relative">
            <button
               className={`button-close`}
               onClick={() => navigate('/')}>
               <img
                  src="/assets/icons/cross-icon.svg"
                  alt="close"
               />
            </button>
            {stepInfo.icon && (
               <img
                  src={stepInfo.icon}
                  alt=""
                  width={80}
               />
            )}

            <div className="flex flex-col items-center gap-4 pl-2 pr-2">
               <h1 className="text-center w-80">{stepInfo.title}</h1>

               {stepInfo.step === 3 ? (
                  <div className="flex flex-col items-center gap-3">
                     <div className="flex flex-col items-center gap-1">
                        <p className="text-center ">
                           An email was sent to: <span className="bold">{signupCheckForm.watch('email')}</span>
                        </p>
                        <p className="gray">If you can't find the email, please check your spam folder.</p>
                     </div>

                     <Link
                        className="green"
                        title="Resend Email"
                        to={getLinkWithParams('')}
                        onClick={signupPasswordForm.handleSubmit((data: SignupPasswordModel) => submitPassword(data, true))}>
                        Resend email
                     </Link>
                  </div>
               ) : (
                  <p
                     className="w-80 text-center large"
                     style={{ maxWidth: '450px' }}>
                     {stepInfo.subtitle}
                  </p>
               )}
            </div>
            {signupStatus === SignupStatuses.Initial && (
               <form
                  onSubmit={signupCheckForm.handleSubmit(submitCheck)}
                  className="signup-form flex flex-col gap-3">
                  <div className="flex flex-col gap-2">
                     {/* Email Field */}
                     <div className="flex gap-2 wrap">
                        <div className="form-group flex-1">
                           <label htmlFor="firstname">First Name</label>
                           <input
                              placeholder="Sam"
                              type="text"
                              id="firstname"
                              {...signupCheckForm.register('firstname')}
                              className={signupCheckForm.formState.errors.firstname ? 'error-input' : ''}
                           />
                           {signupCheckForm.formState.errors.firstname && <p className="error-message">{signupCheckForm.formState.errors.firstname.message as string}</p>}
                        </div>

                        <div className="form-group flex-1">
                           <label htmlFor="lastname">Last Name</label>
                           <input
                              placeholder="Johnson"
                              type="text"
                              id="lastname"
                              {...signupCheckForm.register('lastname')}
                              className={signupCheckForm.formState.errors.lastname ? 'error-input' : ''}
                           />
                           {signupCheckForm.formState.errors.lastname && <p className="error-message">{signupCheckForm.formState.errors.lastname.message as string}</p>}
                        </div>
                     </div>
                     <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                           placeholder="samjohnson@gmail.com"
                           type="email"
                           id="email"
                           {...signupCheckForm.register('email')}
                           className={signupCheckForm.formState.errors.email ? 'error-input' : ''}
                        />
                        {signupCheckForm.formState.errors.email && <p className="error-message">{signupCheckForm.formState.errors.email.message as string}</p>}
                     </div>

                     {/* Name Fields */}

                     {/* <div className="form-group flex-1">
                        <label htmlFor="username">
                           Username <span className="small gray">(optional)</span>
                        </label>
                        <input
                           type="text"
                           id="username"
                           {...signupCheckForm.register('username')}
                           className={signupCheckForm.formState.errors.username ? 'error-input' : ''}
                        />
                        {signupCheckForm.formState.errors.username && <p className="error-message">{signupCheckForm.formState.errors.username.message as string}</p>}
                     </div> */}

                     {/* Country Select Dropdown */}
                     <div className="form-group">
                        <label htmlFor="country">Country</label>
                        <CountrySelect
                           options={countries}
                           value={countries.find((option) => option.value === signupCheckForm.watch('country'))}
                           onChange={(selectedCountry) => signupCheckForm.setValue('country', selectedCountry?.value ?? '', { shouldValidate: true })}
                           placeholder="Select your country"
                        />
                        {signupCheckForm.formState.errors.country && <p className="error-message">{signupCheckForm.formState.errors.country.message as string}</p>}
                     </div>
                     {signupCheckForm.watch('country') === 'Canada' && (
                        <div className="form-group ">
                           <label htmlFor="security-question">
                              What is th result of {securityMathQuestion.a} * {securityMathQuestion.b} + {securityMathQuestion.c}?
                           </label>
                           <input
                              type="text"
                              id="security-question"
                              value={securityMathInput}
                              onChange={(e) => {
                                 const value = e.target.value;

                                 // Allow only integers (positive and negative)
                                 if (/^-?\d*$/.test(value)) {
                                    setSecurityMathInput(value);
                                 }
                              }}
                              className={!securityMathPassed ? 'error-input' : ''}
                           />
                           {!securityMathPassed && securityMathInput !== '' && <p className="error-message">Incorrect answer</p>}
                        </div>
                     )}

                     <div className="form-group flex-1">
                        <label htmlFor="referral-code">
                           Referral Code <span className="small gray">(optional)</span>
                        </label>
                        <input
                           placeholder="Paste 8-digit code here"
                           type="text"
                           id="referral-code"
                           {...signupCheckForm.register('referralCode')}
                           className={signupCheckForm.formState.errors.referralCode ? 'error-input' : ''}
                        />
                        {signupCheckForm.formState.errors.referralCode && <p className="error-message">{signupCheckForm.formState.errors.referralCode.message as string}</p>}
                     </div>
                  </div>

                  {/* Terms & Submit Button */}
                  <div className="flex flex-col gap-2">
                     <div className="form-group flex-1">
                        <Checkbox
                           checked={signupCheckForm.watch('termsAccepted')}
                           onChange={() => {
                              const isChecked = signupCheckForm.watch('termsAccepted');
                              signupCheckForm.setValue('termsAccepted', !isChecked, { shouldValidate: true });
                           }}>
                           <span className="flex items-center gap-1 medium">
                              By continuing, I agree to the
                              <Link
                                 to={'https://account.golfn.com/app-tos'}
                                 // to={'https://www.golfn.com/toc'}
                                 // to={'/terms-and-conditions'}
                                 target="_blank"
                                 className="green medium">
                                 Terms and Conditions.
                              </Link>
                           </span>
                        </Checkbox>
                        {signupCheckForm.formState.errors.termsAccepted && <p className="error-message">{signupCheckForm.formState.errors.termsAccepted.message as string}</p>}
                     </div>
                     <Button
                        title="Continue"
                        buttonType="submit"
                        type="white-big"
                        className="submit-button"
                        disabled={!signupCheckForm.formState.isValid || !securityMathPassed}
                        loading={isLoading}
                     />

                     <div className="flex justify-center">
                        <p>
                           Already have an account?{' '}
                           <Link
                              className="underline"
                              onClick={(e) => {
                                 e.stopPropagation();
                                 setIsLoginModalOpen(true);
                              }}
                              to={getLinkWithParams('/')}>
                              Login
                           </Link>
                        </p>
                     </div>
                  </div>
                  {process.env.REACT_APP_GOOGLE_CLIENT_ID && (
                     <div className="flex justify-center mt-3">
                        <div
                           ref={googleButtonRef}
                           className="google-signin-button"
                           style={{}}></div>
                     </div>
                  )}
               </form>
            )}

            {signupStatus === SignupStatuses.InformationVerified && (
               <form
                  onSubmit={signupPasswordForm.handleSubmit((data: SignupPasswordModel) => submitPassword(data))}
                  className="signup-form flex flex-col gap-3">
                  <div className="flex flex-col gap-2">
                     {/* Email Field */}

                     {/* Password Fields */}
                     <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                           type="password"
                           id="password"
                           {...signupPasswordForm.register('password')}
                           className={signupPasswordForm.formState.errors.password ? 'error-input' : ''}
                        />
                        {signupPasswordForm.formState.errors.password && <p className="error-message">{signupPasswordForm.formState.errors.password.message as string}</p>}
                     </div>
                     <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input
                           type="password"
                           id="confirmPassword"
                           {...signupPasswordForm.register('confirmPassword')}
                           className={signupPasswordForm.formState.errors.confirmPassword ? 'error-input' : ''}
                        />
                        {signupPasswordForm.formState.errors.confirmPassword && (
                           <p className="error-message">{signupPasswordForm.formState.errors.confirmPassword.message as string}</p>
                        )}
                     </div>
                  </div>

                  {/* Terms & Submit Button */}
                  <div className="flex flex-col gap-2">
                     <Button
                        title="Complete My Account"
                        buttonType="submit"
                        type="white-big"
                        className="submit-button"
                        disabled={!signupPasswordForm.formState.isValid || isLoading}
                        loading={isLoading}
                     />
                     <div className="flex justify-center">
                        <p>
                           Already have an account?{' '}
                           <Link
                              className="underline"
                              onClick={(e) => {
                                 e.stopPropagation();
                                 setIsLoginModalOpen(true);
                              }}
                              to={getLinkWithParams('/')}>
                              Login
                           </Link>
                        </p>
                     </div>
                  </div>
               </form>
            )}

            {signupStatus === SignupStatuses.VerificationEmailSent && (
               <div className="form-group">
                  <ValidateEmail
                     hideText={true}
                     email={signupCheckForm.getValues('email')}
                     onSubmit={submitSignup}
                     onCancel={() => setSignupStatus(SignupStatuses.Initial)}
                     isLoading={isLoading}
                     onResend={signupPasswordForm.handleSubmit((data: SignupPasswordModel) => submitPassword(data, true))}
                  />
               </div>
            )}

            <StepProgress
               totalSteps={3}
               currentStep={stepInfo.step}
            />

            {isMobile && (
               <div className="flex flex-col gap-1 justify-center items-center pt-4">
                  <p className=" text-center smaller">© 2025 Evan Schiller. All Rights Reserved. Used under license with GolfN, Inc.</p>
                  <a
                     href="https://evanschillerphotography.com"
                     target="_blank"
                     className="green small"
                     rel="noopener noreferrer">
                     evanschillerphotography.com
                  </a>
               </div>
            )}
         </div>

         {!isMobile && (
            <div className="signup-footer">
               <p className="flex gap-small wrap justify-center">
                  © 2025 Evan Schiller. All Rights Reserved. Used under license with GolfN, Inc.
                  <a
                     href="https://evanschillerphotography.com"
                     target="_blank"
                     rel="noopener noreferrer">
                     evanschillerphotography.com
                  </a>
               </p>
            </div>
         )}
      </div>
   );
}
